// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"604":"4d17eb3c","688":"bc9a058e","839":"c54fade9"}[chunkId] + ".chunk.css";
};